//@flow
import * as Immutable from 'immutable';
import { IntlActions } from 'common/redux/actions/intl';
import { BusinessUnitList } from 'common/models/internal/BusinessUnits';

import type { BusinessUnitResponse } from 'common/redux/actions/intl';

export type ActionType = {
    type: string,
    params: Object,
    businessUnits?: BusinessUnitResponse
};

export const businessUnits = (
    state = Immutable.fromJS({ records: {} }),
    action: ActionType
) => {
    switch (action.type) {
        case IntlActions.FETCH_BU_START: {
            const { clientId } = action.params;
            return state.setIn(['records', clientId, 'isBULoading'], true);
        }

        case IntlActions.FETCH_BU_ERROR: {
            const { clientId } = action.params;
            const newState = state.setIn(
                ['records', clientId, 'isBULoading'],
                false
            );
            return newState.setIn(
                ['records', clientId, 'hasFetchBUErrored'],
                true
            );
        }

        case IntlActions.FETCH_BU_SUCCESS: {
            const {
                params: { clientId },
                businessUnits
            } = action;
            const data = BusinessUnitList.fromJS(businessUnits);
            let newState = state.setIn(
                ['records', clientId, 'businessUnits'],
                data
            );
            newState = newState.setIn(
                ['records', clientId, 'isBULoading'],
                false
            );
            return newState.setIn(
                ['records', clientId, 'hasFetchBUErrored'],
                false
            );
        }

        default:
            return state;
    }
};
